import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import './index.css';

import AdminLayout from './components/AdminLayout';
import Dashboard from './AdminPages/Dashboard';
import PostAnnouncement from './AdminPages/PostAnnouncement';
import Organizations from './AdminPages/Organizations';
import Accreditation from './AdminPages/Accreditation';
import OffCampusActivity from './AdminPages/OffCampusActivity';
import AccessRequests from './AdminPages/AccessRequests';
import Settings from './AdminPages/Settings';
import Notifications from './AdminPages/Notifications';
import AdminProfile from './AdminPages/AdminProfile';
import Login from './AuthPages/Login';
import Signup from './AuthPages/Signup';
import RequestStatus from './AuthPages/RequestStatus';
import ForgotPassword from "./AuthPages/ForgotPassword";
import AdminSetPassword from "./AuthPages/AdminSetPassword";

import UserLayout from './components/UserLayout';
import OrgDashboard from './UserPages/OrgDashboard';
import OrgAccreditation from './UserPages/OrgAccreditation';
import OrgOffCampus from './UserPages/OrgOffCampus';
import OrgAnnouncements from './UserPages/OrgAnnouncements';
import OrgProfile from './UserPages/OrgProfile';
import OrgNotifications from './UserPages/OrgNotifications';
import OrgRequirements from './UserPages/OrgRequirements';
import OrgParticipants from './UserPages/OrgParticipants';
import ParticipantPortal from './UserPages/ParticipantPortal';
import ErrorBoundary from './components/ErrorBoundary';
import { WebSocketProvider } from './context/WebSocketContext';

const App = () => {
  return (
    <WebSocketProvider>
      <HashRouter>
        <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/request-status" element={<RequestStatus />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/admin-setup" element={<AdminSetPassword />} />

        {/* Public Participant Portal — no auth guard */}
        <Route path="/participant/:token" element={<ParticipantPortal />} />

        {/* Admin Routes */}
        <Route path="/admin/*" element={
          <AdminLayout>
            <Routes>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/announce" element={<PostAnnouncement />} />
              <Route path="/organizations" element={<Organizations />} />
              <Route path="/accreditation" element={<Accreditation />} />
              <Route path="/off-campus" element={<OffCampusActivity />} />
              <Route path="/access" element={<AccessRequests />} />
              <Route path="/settings" element={<Navigate to="/admin/settings/deadline" />} />
              <Route path="/settings/deadline" element={<Settings />} />
              <Route path="/settings/requirements" element={<Settings />} />
              <Route path="/settings/notifications" element={<Settings />} />
              <Route path="/settings/academic-year" element={<Settings />} />
              <Route path="/settings/staff" element={<Settings />} />
              <Route path="/notifications" element={<Notifications />} />
              <Route path="/profile" element={<AdminProfile />} />
            </Routes>
          </AdminLayout>
        } />

        {/* User (Organization) Routes */}
        <Route path="/org/*" element={
          <ErrorBoundary>
            <UserLayout>
              <Routes>
                <Route path="/dashboard" element={<OrgDashboard />} />
                <Route path="/accreditation" element={<OrgAccreditation />} />
                <Route path="/off-campus" element={<OrgOffCampus />} />
                <Route path="/announcements" element={<OrgAnnouncements />} />
                <Route path="/requirements" element={<OrgRequirements />} />
                <Route path="/participants" element={<OrgParticipants />} />
                <Route path="/profile" element={<OrgProfile />} />
                <Route path="/notifications" element={<OrgNotifications />} />
              </Routes>
            </UserLayout>
          </ErrorBoundary>
        } />

        {/* Fallback to login */}
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </HashRouter>
  </WebSocketProvider>
  );
};

export default App;

